import React, { useEffect, useMemo, useRef, memo } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Portal,
  chakra,
  usePopper,
} from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";

const wrapperStyles = {
  position: "absolute",
  zIndex: "popover",
  display: "flex",
  alignItems: "center",
  background: "gray.500",
  "--popper-arrow-bg": "var(--chakra-colors-gray-500)",
  boxShadow: "md",
  borderRadius: "md",
  borderWidth: "1px",
  padding: "1",
  maxWidth: "full",
};

const StyledContent = chakra(motion.div);

const AdvancedMessageSelectedTextMenu = ({
  node,
  text,
  range,
  menu,
}) => {
  const ref = useRef(null);
  const { popperRef, referenceRef, getArrowProps, getArrowInnerProps } =
    usePopper({
      placement: "bottom",
      strategy: "fixed",
    });
  const active = useMemo(() => !!(node && text && range), [node, text, range]);

  const setRef = (el) => {
    ref.current = el;
    popperRef(el);
  };

  useEffect(() => {
    referenceRef(node);
  }, [node]);

  if (!active || !menu) {
    return null;
  }

  return (
    <AnimatePresence>
      <Portal>
        <StyledContent sx={wrapperStyles} ref={setRef}>
          <Box>
            {menu}
          </Box>
          <Box {...getArrowProps()}>
            <Box {...getArrowInnerProps()} />
          </Box>
        </StyledContent>
      </Portal>
    </AnimatePresence>
  );
};

AdvancedMessageSelectedTextMenu.propTypes = {
  node: PropTypes.oneOfType([
    PropTypes.instanceOf(Node),
    PropTypes.shape({
      getBoundingClientRect: PropTypes.func.isRequired,
    }),
  ]),
  text: PropTypes.string,
  range: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
  }),
  menu: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]),
};

AdvancedMessageSelectedTextMenu.defaultProps = {
  node: undefined,
  text: undefined,
  range: undefined,
  menu: undefined,
};

export default memo(AdvancedMessageSelectedTextMenu);
